import React from "react";
import {
  Card, CardContent
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";
import { itemWithKeys } from "../../../../../../utils/utils.js.jsx";
import FormFields from "../../../../../../base/form/form_fields.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import { AdminBirthUserModel } from "../../../../../../models/users/admin/birth_user_model.js";
import { AdminUserBirthInfoModel } from "../../../../../../models/users/admin/user_birth_info_model.js"

const styles = theme => ({
});

const BirthInfoCard = (props) => {

  const { classes, onItemChanged, errorData } = props;

  const user = Object.assign({}, props.user) || {};
  user.personalInfo = itemWithKeys(user.personalInfo, AdminUserBirthInfoModel.formFieldsWhitelist(user.personalInfo))

  const formFields = AdminBirthUserModel.formFields({item: user});

  const birthFields = ["personalInfo"];

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.birth")}
        </div>
        <FormFields formFields = { formFields.filter(field => birthFields.includes(field.name)) }
                    item = { itemWithKeys(user, birthFields) }
                    errorData = { errorData }
                    onItemChange = { onItemChanged } />
      </CardContent>
    </Card>
  );
}

BirthInfoCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(BirthInfoCard);
